// extracted by mini-css-extract-plugin
export default {"content":"BoardView_content__IWUFr","lists":"BoardView_lists__a4qVR","list":"BoardView_list__Jer3F"};